<script setup lang="ts">
import type { DropdownMenuItem } from "@nuxt/ui"

defineProps<{
	collapsed?: boolean
}>()

const appConfig = useAppConfig()

const colors = ["red", "orange", "amber", "yellow", "lime", "green", "emerald", "teal", "cyan", "sky", "blue", "indigo", "violet", "purple", "fuchsia", "pink", "rose"]
const neutrals = ["slate", "gray", "zinc", "neutral", "stone"]

const items = computed<DropdownMenuItem[]>(() => {
	return [
		{
			label: "Primary",
			slot: "chip",
			chip: appConfig.ui.colors.primary,
			content: {
				align: "center",
				collisionPadding: 16,
			},
			children: colors.map((color) => ({
				label: color,
				chip: color,
				slot: "chip",
				checked: appConfig.ui.colors.primary === color,
				type: "checkbox",
				onSelect: (e: { preventDefault: () => void }) => {
					e.preventDefault()

					appConfig.ui.colors.primary = color
				},
			})),
		},
		{
			label: "Neutral",
			slot: "chip",
			chip: appConfig.ui.colors.neutral,
			content: {
				align: "end",
				collisionPadding: 16,
			},
			children: neutrals.map((color) => ({
				label: color,
				chip: color,
				slot: "chip",
				type: "checkbox",
				checked: appConfig.ui.colors.neutral === color,
				onSelect: (e: { preventDefault: () => void }) => {
					e.preventDefault()

					appConfig.ui.colors.neutral = color
				},
			})),
		},
	]
})
</script>

<template>
	<UDropdownMenu
		class="mb-2"
		:items="items[0].children"
		:content="{ align: 'center', collisionPadding: 12 }"
		:ui="{ content: collapsed ? 'w-36' : 'w-(--reka-dropdown-menu-trigger-width)' }"
	>
		<UButton
			v-bind="{
				label: items[0].label,
				trailingIcon: collapsed ? undefined : 'i-lucide-chevrons-up-down',
			}"
			icon="i-lucide-chevrons-up-down"
			color="primary"
			variant="solid"
			block
			:square="collapsed"
			:ui="{
				trailingIcon: 'text-(--ui-text-dimmed)',
			}"
		/>

		<template #chip-leading="{ item }">
			<span
				:style="{ '--chip': `var(--color-${(item as any).chip}-400)` }"
				class="ms-0.5 size-2 rounded-full bg-(--chip)"
			/>
		</template>
	</UDropdownMenu>

	<UDropdownMenu
		class="mb-6"
		:items="items[1].children"
		:content="{ align: 'center', collisionPadding: 1 }"
		:ui="{ content: collapsed ? 'w-36' : 'w-(--reka-dropdown-menu-trigger-width)' }"
	>
		<UButton
			v-bind="{
				label: collapsed ? '_' : items[1].label,
				trailingIcon: collapsed ? undefined : 'i-lucide-chevrons-up-down',
			}"
			icon="i-lucide-chevrons-up-down"
			color="neutral"
			variant="outline"
			block
			:square="collapsed"
			:ui="{
				trailingIcon: 'text-(--ui-text-dimmed)',
			}"
		/>

		<template #chip-leading="{ item }">
			<span
				:style="{ '--chip': `var(--color-${(item as any).chip}-400)` }"
				class="ms-0.5 size-2 rounded-full bg-(--chip)"
			/>
		</template>
	</UDropdownMenu>
</template>
